import { useState } from "react";
import css from "./adm.module.css";
import OpicunskaRada from "./mainPages/opicunskaRada";
import AdminProductSelector from "./catalog/adminProductSelector";
import FiltersBooks from "./filters/filtersBooks";
import FiltersManuscript from "./filters/filtersManuscript";
import PriceOptPage from "./priceOtp/priceOptPage";
import CatalogOptCom from "./priceOtp/catalogOptCom";
import LitShowManager from "./priceOtp/litShowManager";
import AutorAndHud from "./autorAndHud";
import AdminForeignRights from "./adminForeignRights";
import NovaPoshtaKeyManager from "./novaPoshta";
import EditSunSoonText from "./EditSunSoonText";
import DiscountAndActionAdmin from "./discountAndActionDynamic";
import AboutAdmin from "./AboutAdmin";
import DeliveryAdmin from "./DeliveryAdmin";
import PublicOfferAdmin from "./PublickOfferAdmin";
import UserCabinetEditor from "./UserCabinetEditor";
import CommercialNewsAdmin from "./main/CommercialNewsAdmin";
import CabinetTilesAdmin from "./users/CabinetTilesAdmin";
import LibraryOffersAdmin from "./LibraryOffersAdmin";
import LibraryCatalogBannerAdmin from "./LibraryCatalogBannerAdmin";
const PageListFor = () => {
  const [mainPage, setMainPage] = useState(false);
  const [opicunskaRada, setOpicunskaRada] = useState(false);
  const [catalogPage, setCatalogPage] = useState(false);
  const [mainBanner, setMainBanner] = useState(false);
  const [filters, setFilters] = useState(false);
  const [filtersBooks, setFiltersBooks] = useState(false);
  const [filtersManuscript, setFiltersManuscript] = useState(false);
  const [priceOpt, setPriceOpt] = useState(false);
  const [actionsAndRoz, setActionsAndRoz] = useState(false);
  const [documentoobig, setDocumentoobig] = useState(false);
  const [litShow, setLitShow] = useState(false);
  const [autorsHudognik, setAutorsHudognik] = useState(false);
  const [foreiRight, setForeiRight] = useState(false);
  const [novaKey, setNovaKey] = useState(false);
  const [changeTextHead, setChangeTextHead] = useState(false);
  const [banerKrohmal, setBanerKrohmal] = useState(false);
  const [aboutPage, setAboutPage] = useState(false);
  const [pageDelivery, setPageDelivery] = useState(false);
  const [pubOfferPage, setPubOfferPage] = useState(false);
  const [userCabinet, setUserCabinet] = useState(false);
  const [banerOnCabB, setBanerOnCabB] = useState(false);
  const [banreFors, setBanreFors] = useState(false);
  const [banerForBib, setBanerForBib] = useState(false);
  const [bannerFotTwoB, setBannerFotTwoB] = useState(false);
  const mainPageClick = () => {
    setMainPage(!mainPage);
    setCatalogPage(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const catalogPageClick = () => {
    setMainPage(false);
    setCatalogPage(!catalogPage);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const opicunscaPageClick = () => {
    setOpicunskaRada(!opicunskaRada);
    setMainPage(false);
    setCatalogPage(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const mainBannerCatalogPageClick = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(!mainBanner);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const filtersPageClick = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(!filters);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const filtersBooksPageClick = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(!filtersBooks);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const filtersManuscriptPageClick = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(!filtersManuscript);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const priceOptPageClick = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(!priceOpt);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const actionsAndRozprodagPageClick = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(!actionsAndRoz);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const documentoobigPageClick = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(!documentoobig);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const liShowPageClick = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(!litShow);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const autorAndHudognuk = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(!autorsHudognik);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const foreiR = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(!foreiRight);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const novaK = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(!novaKey);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const nezabaromText = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(!changeTextHead);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const krohmalText = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(!banerKrohmal);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const functionAboutPage = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(!aboutPage);
    setPageDelivery(false);
    setUserCabinet(false);
    setPubOfferPage(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const functionDeliveryPage = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(!pageDelivery);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const functionPabOfferPage = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(!pubOfferPage);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const functionUserCabinet = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(!userCabinet);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const functionBannerOnCabB = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(!banerOnCabB);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const functionBannerforTwo = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(!banreFors);
    setBanerForBib(false);
    setBannerFotTwoB(false);
  };
  const functionBannerforLib = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(!banerForBib);
    setBannerFotTwoB(false);
  };
  const functionBannerFotTwoBb = () => {
    setOpicunskaRada(false);
    setMainPage(false);
    setCatalogPage(false);
    setMainBanner(false);
    setFilters(false);
    setFiltersBooks(false);
    setFiltersManuscript(false);
    setPriceOpt(false);
    setActionsAndRoz(false);
    setDocumentoobig(false);
    setLitShow(false);
    setAutorsHudognik(false);
    setForeiRight(false);
    setNovaKey(false);
    setChangeTextHead(false);
    setBanerKrohmal(false);
    setAboutPage(false);
    setPageDelivery(false);
    setPubOfferPage(false);
    setUserCabinet(false);
    setBanerOnCabB(false);
    setBanreFors(false);
    setBanerForBib(false);
    setBannerFotTwoB(!bannerFotTwoB);
  };
  return (
    <div className={css.wrapAdmLisPage}>
      <div className={css.buttonWrapInPage}>
        <div className={css.mainPageButtonO} onClick={novaK}>
          Нова пошта ключ
        </div>
        <div className={css.mainPageButtonO} onClick={mainPageClick}>
          Головна
        </div>
        <div className={css.mainPageButtonO} onClick={catalogPageClick}>
          Каталог
        </div>
        <div className={css.mainPageButtonO} onClick={filtersPageClick}>
          Фільтри
        </div>
        <div className={css.mainPageButtonO} onClick={priceOptPageClick}>
          Прайс-гурт
        </div>
        <div className={css.mainPageButtonO} onClick={autorAndHudognuk}>
          Авторам/Художникам
        </div>
        <div className={css.mainPageButtonO} onClick={foreiR}>
          foreign-rights
        </div>
        <div className={css.mainPageButtonO} onClick={nezabaromText}>
          Текст в шапці "Незабаром"
        </div>
        <div className={css.mainPageButtonO} onClick={functionAboutPage}>
          Про видавництво
        </div>
        <div className={css.mainPageButtonO} onClick={functionDeliveryPage}>
          Доставка
        </div>
        <div className={css.mainPageButtonO} onClick={functionPabOfferPage}>
          Публічна оферта
        </div>
        <div className={css.mainPageButtonO} onClick={functionUserCabinet}>
          Кабінет користувача
        </div>
        <div className={css.mainPageButtonO} onClick={functionBannerOnCabB}>
          Банер для Бізнесу в кабінеті
        </div>
        <div className={css.mainPageButtonO} onClick={functionBannerforTwo}>
          Банер для Бізнесу 2
        </div>
        <div className={css.mainPageButtonO} onClick={functionBannerforLib}>
          Банер для Бібліотек
        </div>
        <div className={css.mainPageButtonO} onClick={functionBannerFotTwoBb}>
          Банер для Бібліотек 1
        </div>
      </div>
      {mainPage && (
        <div className={css.buttonWrapInPage}>
          <div className={css.mainPageButtonO} onClick={opicunscaPageClick}>
            Опікунська рада
          </div>
        </div>
      )}
      {filters && (
        <div className={css.buttonWrapInPage}>
          <div className={css.mainPageButtonO} onClick={filtersBooksPageClick}>
            Фільтри книг
          </div>
          <div
            className={css.mainPageButtonO}
            onClick={filtersManuscriptPageClick}
          >
            Фільтри рукописів
          </div>
        </div>
      )}
      {catalogPage && (
        <div className={css.buttonWrapInPage}>
          <div
            className={css.mainPageButtonO}
            onClick={mainBannerCatalogPageClick}
          >
            Головний банер
          </div>
          <div className={css.mainPageButtonO} onClick={krohmalText}>
            Різнокольорові банери в низу сторінки
          </div>
        </div>
      )}
      {priceOpt && (
        <div className={css.buttonWrapInPage}>
          <div
            className={css.mainPageButtonO}
            onClick={actionsAndRozprodagPageClick}
          >
            Акції та розпродаж
          </div>
          <div className={css.mainPageButtonO} onClick={documentoobigPageClick}>
            Документообіг, каталог
          </div>
          <div className={css.mainPageButtonO} onClick={liShowPageClick}>
            Літ шоу
          </div>
        </div>
      )}
      {opicunskaRada && <OpicunskaRada />}
      {mainBanner && <AdminProductSelector />}
      {filtersBooks && <FiltersBooks />}
      {filtersManuscript && <FiltersManuscript />}
      {actionsAndRoz && <PriceOptPage />}
      {documentoobig && <CatalogOptCom />}
      {litShow && <LitShowManager />}
      {autorsHudognik && <AutorAndHud />}
      {foreiRight && <AdminForeignRights />}
      {novaKey && <NovaPoshtaKeyManager />}
      {changeTextHead && <EditSunSoonText />}
      {banerKrohmal && <DiscountAndActionAdmin />}
      {aboutPage && <AboutAdmin />}
      {pageDelivery && <DeliveryAdmin />}
      {pubOfferPage && <PublicOfferAdmin />}
      {userCabinet && <UserCabinetEditor />}
      {banerOnCabB && <CommercialNewsAdmin />}
      {banreFors && <CabinetTilesAdmin />}
      {banerForBib && <LibraryOffersAdmin />}
      {bannerFotTwoB && <LibraryCatalogBannerAdmin />}
    </div>
  );
};
export default PageListFor;
